<!-- <div class="sign-in-page" style="background: var(--neutral-light);">
    <citadel-form-section [heading]="'Citadel Account'">
        <p>Please wait while we redirect you to My Secure Zone.</p>
    </citadel-form-section>
</div> -->
<div class="main">
  <app-page-greeting />
</div>
